import * as Common from '@/tenant/common';

export class ShelfNo extends Common.MasterBase{
  constructor(){
    super('ShelfNo');
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.warehouse = new Common.ModelBinder(Common.Counterpart);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }

  public id: number = 0;
  public commodityId: number = 0;
  public commodity: Common.Commodity = null;
  public warehouseId: number = 0;
  public warehous: Common.Counterpart = null;
  public skuId: number = 0;
  public sku: Common.SKU = null;
  public shelfNo: string = '';

  public copy():any {
    const temp = super.copy() as ShelfNo;
    temp.id = 0;
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export class ShelfNoQuery extends Common.LoadQuery {
  constructor(){
    super('ShelfNoQuery',ShelfNo);
    this.sort = 'commodity';
  }
  public commodityCode: string = '';
  // public commodityName: string = '';  
  // public warehouseCode: string = '';
  // public skuCode: string = '';
  public commodity: Common.Commodity = null;
  public sku: Common.SKU = null;
  public warehouse :Common.Counterpart = null;
  public shelfNo: string = '';
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}